import React, { useRef } from 'react'

import { Buscador } from '../../atomic/molecules/Buscador'
import { required } from '../../../helpers/validations/validators';

export const SearchAfiliadoTraslados = ({ afiliado, setAfiliado }) => {
    const componentRef = useRef();

    return (
        <Buscador 
          ref={componentRef}
          validations={[required]}
          value={afiliado}
          variant="outlined"
          setValue={(val) => setAfiliado(val)}
          label="Nombre y Afiliado | Nro Doc | Nro Afiliado | CUIL"
          endpoint={(inputValue) => `Afiliados/traerPorNombreoDNIoNroAfi/${inputValue}/Todos/Todos`}
          noOptionText={"No se encuentra afiliado"}
          getOptionLabel={(option) => `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`}
          getOptionSelected={(option, value) => option.id_afiliado === value.id_afiliado}
          renderOption={(option) => (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={
                  option.fecha_baja === null
                    ? { color: "green" }
                    : { color: "red" }
                }
              >
                {`${option.apellido_y_nombre}`}
              </span>
              <span
                style={{
                  fontSize: 12,
                }}
              >
                {" "}
                {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
              </span>
            </div>
          )}
        />
    )
}
